import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import EditSponsorForm from "components/Admin/Sponsor/EditSponsorForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";
import _ from "lodash";

const { UPDATE_SPONSOR_SAGA } = constants;

const { updateSponsorSaga, cleanErrors, loadSponsorSaga, cleanSponsor } =
  actions;

class EditSponsor extends Component {
  static propTypes = {
    createSponsor: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    this.state = {
      sponsor: {
        title: "",
        logo: "",
        namespace: "",
        show_sponsor_title: true,
      },
    };
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.props.sponsor, props.sponsor))
      this.setState({
        sponsor: {
          ...this.state.sponsor,
          ...props.sponsor,
        },
      });
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadSponsor(this.props.params.id);
  }

  componentWillUnmount() {
    this.props.cleanSponsors();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const sponsorData = {
      ...this.state.sponsor,
      ...{
        [e.target.name]: input,
      },
    };

    this.setState({ sponsor: sponsorData });
  };

  onSubmit = () => {
    this.props.updateSponsor(this.state.sponsor);
  };

  render() {
    const { errors, errorsFrontend } = this.props;
    return (
      <main className="site--width clearfix-c">
        <EditSponsorForm
          onFieldChange={this.onFieldChange}
          sponsor={this.state.sponsor}
          onSubmit={this.onSubmit}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[UPDATE_SPONSOR_SAGA],
    errorsFrontend: state.errors[`${UPDATE_SPONSOR_SAGA}_FRONTEND`],
    sponsor: state.sponsors.admin.tmp,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateSponsor: (sponsor) => dispatch(updateSponsorSaga(sponsor)),
    cleanErrors: () => dispatch(cleanErrors(UPDATE_SPONSOR_SAGA)),
    loadSponsor: (id) => dispatch(loadSponsorSaga(id)),
    dispatch: dispatch,
    cleanSponsors: () => dispatch(cleanSponsor()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSponsor);



// WEBPACK FOOTER //
// ./src/containers/Admin/Sponsor/EditSponsor.jsx